import React, { lazy } from "react";
import { WithFeatureFlagRoute, withSuspense } from "../routes.tsx";

const WatchlistsPage = lazy(() =>
  import("@features/watchlists/WatchlistsPage.tsx").then((module) => ({
    default: module.WatchlistsPage,
  }))
);

const WatchlistsSinglePage = lazy(() =>
  import("@features/watchlists/watchlist/WatchlistsSinglePage.tsx").then(
    (module) => ({
      default: module.WatchlistsSinglePage,
    })
  )
);

const WatchlistAddPage = lazy(() =>
  import("@features/securities/add/AddPage.tsx").then((module) => ({
    default: module.AddPage,
  }))
);

const SecuritiesSinglePage = lazy(() =>
  import("@features/securities/SecuritiesSinglePage.tsx").then((module) => ({
    default: module.SecuritiesSinglePage,
  }))
);

export default [
  {
    path: "watchlists",
    element: (
      <WithFeatureFlagRoute featureFlag="WATCHLISTS">
        {withSuspense(WatchlistsPage)}
      </WithFeatureFlagRoute>
    ),
    children: [
      {
        path: ":watchlistId",
        element: withSuspense(WatchlistsSinglePage),
      },
      {
        path: ":watchlistId/securities/add",
        element: withSuspense(WatchlistAddPage),
      },
      {
        path: ":watchlistId/securities/:securityId",
        element: withSuspense(SecuritiesSinglePage),
      },
    ],
  },
];
